<template>
    <v-layout class="my-4 border">
        <v-flex class="pa-2">
            <legend tabindex="0" v-html="getQuestionText" />
            <v-radio-group
                class="body-2 ml-6 mt-0"
                :value="value"
                :outline="outline"
                type="radio"
                role="radiogroup"
                tabindex="0"
                :rules="[
                    v => !required || getFormRule('validateFormResponse')(v)
                ]"
                :data-meta-id="metadata.id"
                :id="metadata.name"
                @change="emitValue"
            >
                <v-radio :label="$t('base.yes')" :value="1" />
                <v-radio :label="$t('base.no')" :value="0" />
                <v-radio :label="$t('base.na')" :value="-1" />
            </v-radio-group>
        </v-flex>
    </v-layout>
</template>

<script>
import { formRules } from '@/mixins/form-rules';
import { find, get } from 'lodash';
import { MetadataEnum } from '@/enums';

export default {
    name: 'yes-no-na-question',
    mixins: [formRules],
    props: {
        metadata: { type: Object, required: true },
        outline: { type: Boolean, required: false, default: false },
        required: { type: Boolean, required: false, default: false },
        value: { type: [Number, String], required: false, default: null },
        withIcon: { type: Boolean, required: false, default: false },
        placeholder: { type: String, required: false, default: '' },
    },
    created() {
        if (this.value === '1' || this.value === '-1' || this.value === '0') {
            this.emitValue(parseInt(this.value));
        }
    },
    computed: {
        appendIcon() {
            return this.withIcon ? 'fas fa-user-md' : '';
        },
        questions() {
            return [
                { id: MetadataEnum.AS624_HEALTH_PROBLEMS_QUESTION, text: this.$t('appt.as624.healthProblemsQuestion') },
                { id: MetadataEnum.AS624_IMMUNOSUPPRESSION_QUESTION, text: this.$t('appt.as624.immunosuppressionQuestion') },
                { id: MetadataEnum.AS624_ALLERGIC_REACTIONS_QUESTION, text: this.$t('appt.as624.allergicReactionsQuestion') },
                { id: MetadataEnum.AS624_BLEEDING_DISORDER_QUESTION, text: this.$t('appt.as624.bleedingDisorderQuestion') },
                { id: MetadataEnum.AS624_HAS_BLOOD_TRANSFUSION_QUESTION, text: this.$t('appt.as624.hasBloodTransfusionQuestion') },
                { id: MetadataEnum.AS624_PREGNANCY_QUESTION, text: this.$t('appt.as624.pregnancyQuestion') },
                { id: MetadataEnum.AS624_LESS_THAN_SIX_MONTHS_MOTHER_TREATMENT_QUESTION, text: this.$t('appt.as624.lessThanSixMonthsMotherTreatmentQuestion') },
                { id: MetadataEnum.AH635_HEALTH_PROBLEMS_QUESTION, text: this.$t('appt.ah635.healthProblems') },
                { id: MetadataEnum.AH635_ALLERGIC_REACTIONS_QUESTION, text: this.$t('appt.ah635.allergicReactions') },
                { id: MetadataEnum.AH635_BLEEDING_DISORDER_QUESTION, text: this.$t('appt.ah635.bleedingDisorder') },
                { id: MetadataEnum.AH635_IMMUNIZATION_QUESTION, text: this.$t('appt.ah635.immunization') },
                { id: MetadataEnum.AH635_IMMUNOSUPPRESSION_QUESTION, text: this.$t('appt.ah635.immunosuppression') },
                { id: MetadataEnum.AH635_PREGNANCY_QUESTION, text: this.$t('appt.ah635.pregnancyQuestion') },
                { id: MetadataEnum.INFLUENZA_HAS_BLOOD_TRANSFUSION, text: this.$t('appt.influenza.hasBloodTransfusion') },
                { id: MetadataEnum.INFLUENZA_HAS_IMMUNOCOMPROMISED_CONTACT, text: this.$t('appt.influenza.hasImmunocompromisedContact') },
                { id: MetadataEnum.INFLUENZA_HAS_SEVERE_REACTION, text: this.$t('appt.influenza.hasSevereReaction') },
                { id: MetadataEnum.INFLUENZA_HEALTH_STATUS, text: this.$t('appt.influenza.healthStatus') },
                { id: MetadataEnum.INFLUENZA_IS_HEALTH_CARE_WORKER, text: this.$t('appt.influenza.isHealthCareWorker') },
                { id: MetadataEnum.INFLUENZA_IS_IMMUNOSUPPRESSIVE, text: this.$t('appt.influenza.isImmunosuppressive') },
                { id: MetadataEnum.INFLUENZA_IS_PREGNANT, text: this.$t('appt.influenza.isPregnant') },
                { id: MetadataEnum.INFLUENZA_PEOPLE_WHO_LIVE_WITH_ME, text: this.$t('appt.influenza.peopleWhoLiveWithMe') },
                { id: MetadataEnum.INFLUENZA_RECEIVED_PNEUMOCOCCAL_VACCINE, text: this.$t('appt.influenza.receivedPneumococcalVaccine') },
                { id: MetadataEnum.INFLUENZA_RECEIVED_SHINGLES_VACCINE, text: this.$t('appt.influenza.receivedShinglesVaccine') },
                { id: MetadataEnum.INFLUENZA_RECEIVED_VACCINE_LAST_MONTH, text: this.$t('appt.influenza.receivedVaccineLastMonth') },
            ];
        },
        getQuestionText() {
            return (this.required ? '* ' : '') + get(find(this.questions, { id: this.metadata.id }), 'text');
        },
    },
    methods: {
        emitValue(value) {
            this.$emit('update:value', value);
        },
    },
};
</script>

<style lang="scss" scoped>
.border::v-deep {
    border: 2px solid var(--v-primary-base)!important;
    border-radius: 4px!important;
}
</style>
